import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  margin: auto;

  .wrapper {
    margin: auto;
    margin-top: 10px;
    text-align: left;
    box-sizing: border-box;
    width: 100%;
    background: white;
    border-radius: 10px;
    padding: 20px;
    height: calc(100vh - 150px);

    h2 {
      font-family: "GT Super Text";
      margin: 0 0 1em 0;
      font-size: 35px !important;
    }

    .chats {
      height: calc(100% - 120px);

      overflow-y: auto;
      position: relative;

      .line {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        gap: 15px;

        span {
          margin-left: 1em;
          font-size: 12px;
          color: #999;
        }
        .role {
          flex: 0 0 auto;
          width: 50px;
          color: #777;
          line-height: 1.25em;
        }
        .content {
          line-height: 1.25em;

          .reading {
            font-size: 10px;
            background-color: #ddd;
            display: inline-block;
            padding: 3px 7px;
            border-radius: 5px;
            margin-bottom: 8px;
            margin-right: 5px;
          }

          .think {
            font-style: italic;
            color: #777;
          }
        }
      }
    }
    .send {
      margin-top: 10px;
      margin-bottom: 0px;

      textarea {
        width: calc(100%);
        box-sizing: border-box;
        height: 2.2em;
        padding: 9px;
        font-size: 15px;
        border: 1px solid #ccc;
        min-width: 0;
        min-height: 0;
        margin-bottom: 0;
        line-height: 1.2em;
      }

      button {
        position: relative;
        top: -10px;
        margin-left: 1em;
      }
    }

    &.fullscreen {
      position: fixed;
      margin-top: 0px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 0;
      z-index: 1000000;
      height: 100%;
      padding: 5em;
      font-family: "GT Super Text";
      background-color: #ffdee9;
      background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);

      .chats {
        font-size: 25px;
        .line {
          gap: 3em;
        }
      }

      .actions {
        a {
          font-size: 19px;
          background: none;
          border: 1px solid #1aa39d;
          border-radius: 20px;
          padding: 1em;
        }
      }
    }

    .actions {
      display: flex;
      margin-bottom: 10px;
      padding: 10px 10px 10px 0;
      gap: 15px;
      justify-content: center;

      a {
        font-size: 12px;
        background: #ddd;
        padding: 5px 10px;
        display: block;
        border-radius: 5px;
        color: #333;
        margin-left: 0;

        &:hover {
          background: #eee;
        }
      }
    }
  }
`;
